import { useCallback, useEffect, useState } from 'react';
import { connectorOrigin, connectorRequest } from './connectorApi';

export function useConnectorAccount(user) {
  const [revision, setRevision] = useState(0);
  const [state, setState] = useState({ loading: Boolean(connectorOrigin), data: null, error: '' });
  const refresh = useCallback(() => setRevision(value => value + 1), []);
  useEffect(() => {
    const controller = new AbortController();
    if (!connectorOrigin || !user) {
      setState({ owner: user?.uid, loading: false, data: null, error: 'not_configured' });
      return () => controller.abort();
    }
    setState({ owner: user.uid, loading: true, data: null, error: '' });
    Promise.all(['status', 'connections', 'usage'].map(path => connectorRequest(user, path, { signal: controller.signal })))
      .then(([status, connections, usage]) => {
        if (!controller.signal.aborted) setState({ owner: user.uid, loading: false, error: '', data: { ...status, ...connections, ...usage } });
      })
      .catch(error => {
        if (!controller.signal.aborted) setState({ owner: user.uid, loading: false, data: null, error: error.code || 'unavailable' });
      });
    return () => controller.abort();
  }, [user, revision]);
  // Never display the previous employer's balance during an account switch.
  return { ...(state.owner === user?.uid ? state : { loading: true, data: null, error: '' }), refresh };
}
